<template>
  <div class="page-shoes container">
    <ShoesModal :data="modalData" v-show="modalIsOpen" />
    <div class="page-shoes__logo row center-xs">
      <Logo color />
    </div>
    <div class="page-shoes__intro">
      <h1>
        Bienvenue<br />
        <span class="name">{{ user.surname }}</span>
        <img src="@/assets/images/emoji-hi.png" alt="hi" />
      </h1>
      <div class="subtext">
        <p>
          Nous sommes très heureux de t’accueillir sur la bêta Sneakbox !
        </p>
        <!-- <p>
          Pour rappel, en vous abonnant à la Sneakbox vous accédez tous les mois
          aux paires de notre collection que vous pouvez échanger à n’importe
          quel moment.
        </p> -->
        <p>
          Chaque mois, tu as la possibilité de sélectionner une paire et de la
          recevoir chez toi !<br />
          Si tu as des questions, n’hésites pas à visiter notre FAQ.
        </p>
      </div>
      <router-link to="/faq">
        <div class="page-shoes__intro__button">Lire la FAQ</div>
      </router-link>
    </div>
    <div class="page-shoes__shoes">
      <div class="page-shoes__shoes__title">
        <h2>Quelle paire souhaitez-vous porter ce mois-ci ?</h2>
        <p>
          Toutes les paires affichées sont disponibles dans
          <span>votre pointure</span>
        </p>
      </div>
      <div class="page-shoes__shoes__selection">
        <h2>Les paires que nous vous conseillons</h2>
        <div
          v-for="shoe in shoesSelection"
          :key="shoe"
          class="page-shoes__selection__item col-xs-12"
        >
          <ShoesCard :id="shoe" @click.native="openShoeModal(shoe)" selection />
        </div>
      </div>
      <div class="page-shoes__shoes__list row">
        <div
          v-for="shoe in shoes"
          :key="shoe"
          class="page-shoes__shoes__item col-xs-12 col-md-6"
        >
          <ShoesCard :id="shoe" @click.native="openShoeModal(shoe)" />
        </div>
      </div>
    </div>
    <div class="bg-form">
      <div class="shape1"></div>
      <!-- <div class="shape2"></div> -->
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Logo from "@/components/Common/Logo";
// import Button from "@/components/Common/Button";
import ShoesCard from "@/components/Shoes/ShoesCard";
import ShoesModal from "@/components/Shoes/ShoesModal";
export default {
  name: "Shoes",
  components: {
    Logo,
    // Button,
    ShoesCard,
    ShoesModal
  },
  data() {
    return {
      name: "Mohamed",
      modalData: {
        id: "",
        name: "",
        state: "",
        date: "",
        color: "",
        price: "",
        desc: "",
        images: [""]
      }
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      shoes: state => state.auth.user.shoes,
      shoesSelection: state => state.auth.user.shoesSelection,
      shoesBase: state => state.shoes,
      modalIsOpen: state => state.display.modalIsOpen
    })
  },
  methods: {
    ...mapMutations({
      updateModalIsOpen: "updateModalIsOpen",
      updateBodyNoScroll: "updateBodyNoScroll"
    }),
    openShoeModal(data) {
      this.modalData = this.shoesBase.find(shoe => shoe.id === data);
      this.updateModalIsOpen(true);
      this.updateBodyNoScroll(true);
    },
    closePopin() {
      this.updateBodyNoScroll(false);
      this.updateModalIsOpen(false);
    }
  },
  beforeRouteUpdate(to, from, next) {
    console.log("beforeRouteUpdate")
    if (this.modalIsOpen) {
      this.closePopin();
      console.log("ClosePopin")
      next(false);
    } else {
      console.log("Quit")
      next();
    }
  },
  beforeRouteLeave(to, from, next) {
    console.log("beforeRouteLeave")
    if (this.modalIsOpen) {
      this.closePopin();
      console.log("ClosePopin")
      next(false);
    } else {
      console.log("Quit")
      next();
    }
  }
};
</script>

<style lang="scss">
.page-shoes {
  @media #{$md-and-up} {
    max-width: 80rem;
  }
  padding-bottom: 5rem;
  &__logo {
    margin: 4rem 0 5rem;
  }
  &__intro {
    padding-left: 1rem;
    margin-bottom: 8rem;
    max-width: 100vw;
    overflow: hidden;
    > h1 {
      font-size: 5.6rem;
      font-weight: bold;
      line-height: 1.2em;
      color: get($theme, "primary");
      @media #{$md-and-down} {
        font-size: 4rem;
      }
      .name {
        color: get($colors, "white");
        letter-spacing: 0.8rem;
        // background: get($theme, "gradient-1");
        // background-clip: text;
        // -webkit-background-clip: text;
        // -webkit-text-fill-color: transparent;
        @include text-border(2px, get($theme, "primary"));
      }
      img {
        max-height: 0.8em;
        margin-left: 1.5rem;
      }
    }
    .subtext {
      margin-top: 2rem;
      // padding-left: 2rem;
      // border-left: 1rem solid get($theme, "primary");
      > p {
        margin-bottom: 1em;
      }
      @media #{$md-and-down} {
        border-left: none;
        padding-left: 0;
      }
    }
    &__button {
      position: relative;
      display: inline-block;
      // margin-left: 2rem;
      padding: 0 1rem;
      @media #{$md-and-up} {
        cursor: pointer;
      }
      transition: all get($times, "fast");
      &::after {
        content: "";
        display: block;
        width: 100%;
        height: 1.3rem;
        position: absolute;
        left: 0;
        bottom: 0rem;
        background: get($theme, "primary");
        opacity: 0.3;
        z-index: -1;
        transition: all get($times, "fast");
      }
      &:hover {
        color: white;
        &:after {
          height: 2.5rem;
          opacity: 0.7;
        }
      }
      @media #{$md-and-down} {
        margin-left: 0;
      }
    }
  }
  &__shoes {
    &__title {
      text-align: center;
      margin-bottom: 2rem;
      > h2 {
        font-size: 2rem;
        font-weight: bold;
        margin-bottom: 0.5em;
      }
      > p {
        color: get($colors, "grey");
      }
    }
    &__item {
      padding: 1rem;
    }
    &__selection {
      h2 {
        font-size: 1.8rem;
        font-weight: bold;
        margin: 3em 0 2rem;
      }
    }
  }
}
.bg-form {
  .shape1 {
    position: absolute;
    top: 0;
    left: 0;
    width: 20rem;
    height: 100%;
    background: url("~@/assets/images/Path1.svg") no-repeat;
    background-position: top left;
    background-size: 100%;
    z-index: -1;
    @media #{$md-and-down} {
      width: 10rem;
      top: 50%;
    }
  }
  .shape2 {
    position: absolute;
    top: 150%;
    right: 0;
    width: 20rem;
    height: 100%;
    background: url("~@/assets/images/Path2.svg") no-repeat;
    background-position: top left;
    background-size: 100%;
    transform: rotate(180deg);
    z-index: -1;
  }
}
</style>
